import React, { useState, useEffect } from "react";
import { Logo } from "../components/Logos/Logo";
import MainImage from "./MainImage";
import NewsText from "./NewsText";
import { BottomAd } from "../components/adfoxBlocks/BottomAd";
import { AdfoxBlock } from "../components/adfoxBlocks/AdfoxBlock";
import Sidebar from "./Sidebar";
import SmiWidget from "../components/smiWidgets/SmiWidget";
import SmiJs from "../components/SmiJs";
import BlurReload from "../utils/blurReload";
import BackClick from "../components/smiWidgets/BackClick";
import Popup from "../components/smiWidgets/Popup";
import { adfoxOptions } from "./adfox/adfoxOptions";
import { widgetIds } from "./smiWidgets/widgetIds";
import { AdSlot } from "../components/ads/AdSlot";
import { isDbMode, resolveRefresh, resolveSlotSettings, resolveSlotValue } from "../utils/adConfig";
import { AdfoxInvisible } from "../components/adfoxBlocks/InvisibleAdfox";
import { AdfoxHeaderBidding } from "../components/AdfoxHeaderBidding";
import MoeVideo from "../components/smiWidgets/MoeVideo";
import { hbConfig } from "./HeaderBidding/HBConfig";
import { SourceInfo } from "../components/SourceInfo/SourceInfo";
import AnalyticsTracker from "../components/AnalyticsTracker";

export default function Template2001Component({
    news,
    context,
    isFull,
    isDesktop,
    showPopUp,
    showBackClick,
    refreshTime,
    popUpType,
    showMainLogo,
    fprVersion,
    currentDomain,
}) {
    const showFullscreen = fprVersion === "14556_new" && !isDesktop;

    const adBlocks = adfoxOptions[fprVersion] || adfoxOptions["main"];
    const widgetBlocks = widgetIds[fprVersion] || widgetIds["main"];
    // Кампания в БД: реклама только оттуда, блоки мимо AdSlot выключаются этим флагом.
    const dbMode = isDbMode();
    // Прилипание берётся из БД целиком; бандл работает, только если кампании в БД нет.
    // В режиме БД незаполненная настройка — нейтральное значение, а не бандл.
    const dbSidebar = resolveSlotSettings("sidebar", { isFull, isDesktop });
    const sidebarSticky = dbSidebar ? dbSidebar.isSticky : dbMode ? true : widgetBlocks.sideBar.isSticky;

    const backClickIds = resolveSlotValue("backclick", { isFull, isDesktop, fallback: widgetBlocks.backClick });
    const popupIds = resolveSlotValue("popup", { isFull, isDesktop, fallback: widgetBlocks.popup });
    const {
        page: refreshPage,
        useRss: refreshRss,
        rssUrl: refreshRssUrl,
        delay: refreshDelay,
    } = resolveRefresh({
        isFull,
        isDesktop,
        fallback: widgetBlocks.refresh,
    });

    let sid = context.analytics_lable;

    return (
        <div id="wrapper">
            <AdfoxHeaderBidding hbConfig={hbConfig} templateVersion={fprVersion} />
            {showBackClick && (!dbMode || backClickIds) && (
                <BackClick
                    mode="redirect"
                    isDesktop={isDesktop}
                    adIds={backClickIds}
                    domain={currentDomain}
                    showFullscreen={showFullscreen}
                />
            )}
            {showPopUp && (!dbMode || popupIds) && (
                <Popup isDesktop={isDesktop} popUpType={popUpType} adIds={popupIds} domain={currentDomain} />
            )}
            {(!dbMode || refreshPage || refreshRss) && (
                <BlurReload
                    isDesktop={isDesktop}
                    domain={currentDomain}
                    refresh={refreshPage}
                    useRss={refreshRss}
                    rssUrl={refreshRssUrl}
                    delay={refreshDelay}
                    sid={sid}
                    timeout={refreshTime}
                />
            )}
            <SmiJs context={context} />
            <AdSlot
                slot="push"
                isFull={isFull}
                isDesktop={isDesktop}
                json={null}
                fallback={<SmiWidget blockIds={widgetBlocks.push} isFull={isFull} isDesktop={isDesktop} />}
            />
            <AdSlot
                slot="fullscreen"
                isFull={isFull}
                isDesktop={isDesktop}
                json={null}
                fallback={<AdfoxBlock isFull={isFull} isDesktop={isDesktop} options={adBlocks.fullscreen} />}
            />
            <img src="https://data.24smi.net/ctp?id=1" width="1" height="1" />
            <div className="wrapper-holder">
                <header id="header" className="flex">
                    <strong className="logo">
                        <a href="#">
                            <Logo isDark={true} showMainLogo={showMainLogo} />
                        </a>
                    </strong>
                </header>
                <main id="main">
                    <AdSlot
                        slot="topad"
                        isFull={isFull}
                        isDesktop={isDesktop}
                        json={null}
                        fallback={<AdfoxBlock isFull={isFull} isDesktop={isDesktop} options={adBlocks.topad} />}
                    />
                    <div className="main-holder flex">
                        <section id="content">
                            <div className="post-picture">
                                <div className="news-title-200">{news.title}</div>
                                <MainImage news={news} />
                                <SourceInfo url={news.source_url} title={news.source_title} />
                            </div>
                            <NewsText
                                news={news}
                                isFull={isFull}
                                isDesktop={isDesktop}
                                options={adBlocks}
                                dbMode={dbMode}
                            />
                            <AdSlot
                                slot="aa1"
                                isFull={isFull}
                                isDesktop={isDesktop}
                                json={null}
                                fallback={<AdfoxBlock isFull={isFull} isDesktop={isDesktop} options={adBlocks.aa1} />}
                            />
                            <AdSlot
                                slot="aa2"
                                isFull={isFull}
                                isDesktop={isDesktop}
                                json={null}
                                fallback={
                                    <SmiWidget blockIds={widgetBlocks.aa2} isFull={isFull} isDesktop={isDesktop} />
                                }
                            />
                            <div className="container-post look-also" id="look-also">
                                <h3>Смотрите также</h3>
                                <div className="box">
                                    <AdSlot
                                        slot="lookalso"
                                        isFull={isFull}
                                        isDesktop={isDesktop}
                                        json={null}
                                        fallback={
                                            <SmiWidget
                                                blockIds={widgetBlocks.lookAlso}
                                                isFull={isFull}
                                                isDesktop={isDesktop}
                                            />
                                        }
                                    />
                                </div>
                            </div>
                            {!fprVersion && (
                                <AdSlot
                                    slot="feed"
                                    isFull={isFull}
                                    isDesktop={isDesktop}
                                    json={null}
                                    fallback={
                                        <SmiWidget blockIds={widgetBlocks.feed} isFull={isFull} isDesktop={isDesktop} />
                                    }
                                />
                            )}
                            <AdfoxInvisible isTop={true} />
                            <AdfoxInvisible isTop={false} />
                        </section>
                        <Sidebar isSticky={sidebarSticky}>
                            <AdSlot
                                slot="sidebar"
                                isFull={isFull}
                                isDesktop={isDesktop}
                                json={null}
                                fallback={
                                    <SmiWidget blockIds={widgetBlocks.sideBar} isFull={isFull} isDesktop={isDesktop} />
                                }
                            />
                        </Sidebar>
                    </div>
                    {fprVersion && (
                        <AdSlot
                            slot="feed"
                            isFull={isFull}
                            isDesktop={isDesktop}
                            json={null}
                            fallback={<SmiWidget blockIds={widgetBlocks.feed} isFull={isFull} isDesktop={isDesktop} />}
                        />
                    )}
                    <footer className="down" />
                </main>
            </div>
            <AdSlot
                slot="floorad"
                isFull={isFull}
                isDesktop={isDesktop}
                json={null}
                fallback={
                    widgetBlocks.moeVideo ? (
                        <MoeVideo placements={widgetBlocks.moeVideo} isFull={isFull} isDesktop={isDesktop} />
                    ) : (
                        <BottomAd isFull={isFull} isDesktop={isDesktop} options={adBlocks.floorad} />
                    )
                }
            />
            <AdSlot
                slot="empty"
                isFull={isFull}
                isDesktop={isDesktop}
                json={null}
                fallback={<SmiWidget blockIds={widgetBlocks.empty} isFull={isFull} isDesktop={isDesktop} />}
            />
            <AnalyticsTracker
                newsId={news.id}
                streamId={context.stream_id}
                isFull={isFull}
                sessionId={context.session_id}
                visitorId={context.visitor_id}
                utmParams={context.utm_params}
                device={context.device}
                browser={context.browser}
            />
        </div>
    );
}
